function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  height: "512",
  viewBox: "0 0 511.448 511.448",
  width: "512"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M436.508 74.94c-99.913-99.913-261.64-99.927-361.567 0-99.913 99.913-99.928 261.64 0 361.567 99.913 99.913 261.64 99.928 361.567 0 99.912-99.912 99.927-261.639 0-361.567zM234.057 330.39c0 11.598-9.402 21-21 21s-21-9.402-21-21V181.057c0-11.598 9.402-21 21-21s21 9.402 21 21zm85.333 0c0 11.598-9.402 21-21 21s-21-9.402-21-21V181.057c0-11.598 9.402-21 21-21s21 9.402 21 21z",
  "data-original": "#000000",
  className: styles["active-path"] || "active-path",
  "data-old_color": "#000000"
})));